module.exports = __webpack_public_path__ + "media/images/application/template/placeholder-67ff9c61018b1d64b60b69db3382a972.png";